import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconEdit2",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function _(e, t, r, h, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--edit-2"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Edit 2",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.768.732a1.914 1.914 0 0 1 2.086 3.122l-6.75 6.75a.5.5 0 0 1-.222.128l-2.75.75a.5.5 0 0 1-.614-.614l.75-2.75a.5.5 0 0 1 .129-.222l6.75-6.75a1.91 1.91 0 0 1 .62-.414Zm.382.923a.914.914 0 0 1 .997 1.491L4.5 8.793 3.207 7.5l5.647-5.646a.914.914 0 0 1 .296-.199Zm-7.437 8.632.485-1.777.302-.303L3.793 9.5l-.302.303-1.778.484Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const S = /* @__PURE__ */ u(c, [["render", _]]);
export {
  S as default
};
//# sourceMappingURL=edit-2.js.map
